import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import {
  MatDialog,
  MatTableDataSource,
  PageEvent,
  MatPaginator,
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDatepickerInputEvent,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import { CommonModalComponent } from "src/app/pages/common-dialog-management/common-dialog.component";
import { Router, ActivatedRoute } from "@angular/router";
import { BetConfigReqParams } from "src/_models";
import {
  roleTypeOperator,
  roleTypeSap,
  disableConfigData,
  SapRoles,
} from "src/_constants/roleType";
import { Location } from "@angular/common";
import { DialogData } from "../color-configuration/color-configuration.component";
import * as moment from "moment";

@Component({
  selector: "app-competition-management",
  templateUrl: "./competition-management.component.html",
  styleUrls: ["./competition-management.component.scss"],
})
export class CompetitionManagementComponent implements OnInit {
  DisplayedColumns: string[] = [
    "CompetitionId",
    "CompetitionName",
    "Status",
    "Action",
  ];
  competitionData = new MatTableDataSource<any>();
  newCompetitionData = new MatTableDataSource<any>();
  operatorData = new MatTableDataSource<any>();
  providers = [];
  sportsData = [];
  count: number = 0;
  ProviderId: string = "";
  OperatorId: string = "";
  title: string = "Provider Management";
  sportId: string = "";
  selectedSport = "all";
  configData: any;
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  filterBy?: string;
  page?: number;
  pageSize?: number;
  ListFilters: any;
  totalRecords: number;
  search: string = "";
  showOperatorData: boolean = true;
  showSAPData: boolean = true;
  sapRoles = SapRoles;
  selected: any = {
    startDate: moment().subtract(5, "days").startOf("day"),
    endDate: moment().add(2, "days").endOf("day"),
  };
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  constructor(
    private appService: AppService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit() {
    if (this.sapRoles.RolexAdmin === this.userRole.role) {
      this.DisplayedColumns = [ "CompetitionId","CompetitionName","Status"]
    }
    if (disableConfigData.includes(this.userRole.role)) {
      this.DisplayedColumns = this.DisplayedColumns.filter(
        (item) => item !== "Action"
      );
    }
    this.showOperatorData = roleTypeOperator.includes(this.userRole.role) || this.userRole.role === SapRoles.GroupAdmin;
    this.showSAPData = roleTypeSap.includes(this.userRole.role);
    // this.getOurProviders();
    this.OperatorId = this.route.snapshot.params.operator;
    this.ProviderId = this.route.snapshot.params.provider;
    this.sportId = this.route.snapshot.params.sport;
    this.onChangeSports(this.route.snapshot.params.sport);
    if (this.userRole.role === SapRoles.GroupAdmin) {
      this.title = this.OperatorId + " / " + this.title;
    }
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;

  goTo(link) {
    let linkRoute =
      `/administration/providers/${this.OperatorId}/${this.ProviderId}/${this.sportId}/` + link.CompetitionId;
      const queryParams = { startDate: new Date(this.selected.startDate).getTime(), endDate: new Date(this.selected.endDate).getTime() };
      this.appService.setCompetition(link);
    this.router.navigate([linkRoute],{queryParams});
  }

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.selected.endDate.diff(this.selected.startDate, "days") > 7) {
      this.selected.startDate = moment().subtract(5, "days").startOf("day");
      this.selected.endDate = moment().add(2, "days").endOf("day");
      alert("You can only check data for 7 days!!")
    } else {
      this.getOurCompetition(this.ProviderId, this.sportId);
    }
  };

  getList(event?: PageEvent, userId?: string) {
    const pagination = {
      Number: 10,
      Page: 1,
    };

    if (event && event.pageIndex) {
      this.page =
        event.pageIndex > event.previousPageIndex
          ? event.pageIndex + 1
          : event.pageIndex - 1;
    }

    let filters = {
      page: this.page,
      pageSize: this.pageSize,
    };
    console.log("filters", filters);
  }

  goToLink(link) {
    this.router.navigate([link]);
  }

  goBack = () => {
    this.location.back();
  };

  getOurCompetition = (pid, sid) => {
    try {
      this.appService.getCompetitionData(this.OperatorId, pid, sid, new Date(this.selected.startDate).getTime(), new Date(this.selected.endDate).getTime()).subscribe((res) => {
        if (res.status === "RS_OK") {
          // this.competitionData = res.Competition;
          this.competitionData = new MatTableDataSource<any>(res.Competition);
          this.newCompetitionData = new MatTableDataSource<any>(
            res.Competition
          );
          this.competitionData.paginator = this.paginator;
          this.totalRecords = res.Competition.length;
        }
      });
    } catch (err) {}
  };
  getOurProviders() {
    try {
      this.appService.getOurProviders().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.providers = res.providers;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }
  onSelectedProvider = (pid) => {
    this.ProviderId = pid;
    this.selectedSport = "all";
    this.competitionData = new MatTableDataSource<any>();
    this.newCompetitionData = new MatTableDataSource<any>();
    this.getSportData(pid);
  };
  getSportData = (pid) => {
    try {
      this.appService.getSportCatalogData(this.OperatorId, pid).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.sportsData = res.sports;
        }
      });
    } catch (err) {}
  };
  onChangeSports = (sid) => {
    this.sportId = sid;
    this.getOurCompetition(this.route.snapshot.params.provider, sid);
  };
  handleSearch = (event) => {
    const { target } = event;
    const { name, value } = target;
    this.search = value;
    if (value.length) {
      let data = this.newCompetitionData.data.filter(
        (item) =>
          item.CompetitionName.toLowerCase().includes(value.toLowerCase()) ||
          item.CompetitionId.toLowerCase().includes(value.toLowerCase())
      );
      this.competitionData = new MatTableDataSource<any>(data);
      this.competitionData.paginator = this.paginator;
    } else {
      this.competitionData = this.newCompetitionData;
    }
  };
  handleChangeStatus(e, data) {
    let providerid = this.ProviderId;
    let sportId = this.sportId;
    if (e.checked) {
      this.appService
        .unBlockCompititions(this.OperatorId, providerid, sportId, data.CompetitionId)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription);
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
          this.getOurCompetition(this.ProviderId, this.sportId);
        });
    } else {
      this.appService
        .blockCompititions(this.OperatorId, providerid, sportId, data.CompetitionId)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription);
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }

          this.getOurCompetition(this.ProviderId, this.sportId);
        });
    }
  }

  changeStatus = (data) => {
    if (this.showSAPData) {
      try {
        this.appService
          .getOperatorsData({
            ProviderId: this.ProviderId,
            SportId: this.sportId,
            CompetitionId: data.CompetitionId,
            EventId: "",
          })
          .subscribe((res) => {
            if (res.status === "RS_OK") {
              this.operatorData.data = res.providers;
              this.dialog.open(CommonModalComponent, {
                backdropClass: "backdropBackground",
                hasBackdrop: true,
                data: {
                  providersStatus: this.operatorData,
                  title: data.CompetitionName,
                  proStatus: data.status,
                  ProviderId: this.ProviderId,
                  sportId: this.sportId,
                  CompetitionId: data.CompetitionId,
                  EventId: "",
                  For: "SAP",
                  code: 0,
                  level: "competition",
                },
              });
            }
          });
      } catch (err) {}
    }
  };

  uploadThumbnail = (data) => {
    this.appService
      .getCompetitionThumbnails({
        providerId: this.ProviderId,
        sportId: this.sportId,
        competitionId: data.CompetitionId,
      })
      .subscribe(
        (res) => {
          this.dialog.open(UploadModalComponent, {
            backdropClass: "backdropBackground",
            hasBackdrop: true,
            data: {
              cid: data.CompetitionId,
              pid: this.ProviderId,
              thumbnails: res.thumbnailUrls,
              selectedThumbnails: res.competitionThumbnails === null? [] : res.competitionThumbnails,
            },
          });
        },
        (err) => {}
      );
  };

  getExportExcel() {
    try {
      this.appService
        .getCompetitionDataList(this.ProviderId, this.sportId)
        .subscribe((res) => {
          const contentType = "application/vnd.ms-excel";
          let blob1 = this.b64toBlob(res.file, contentType);
          let blobUrl1 = URL.createObjectURL(blob1);
          const link = document.createElement("a");
          link.href = blobUrl1;
          link.setAttribute("download", `catalogue-competitions.xlsx`);
          document.body.appendChild(link);
          link.click();
        });
    } catch (err) {}
  }

  b64toBlob(b64Data, contentType, sliceSize?) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  handleClick(data) {
    const postBody: BetConfigReqParams = {
      ConfigCall: "competition",
      PartnerId: data.partnerId,
      ProviderId: this.ProviderId,
      SportId: this.sportId,
      CompetitionId: data.CompetitionId,
      EventId: "",
      OperatorId: this.OperatorId,
    };

    this.dialog.open(CommonModalComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        ConfigData: null, //
        ConfigCall: null, //
        For: "OP",
        page: "competition",
        OperatorId: this.OperatorId,
        ProviderId: this.ProviderId,
        SportId: this.sportId,
        CompetitionId: data.CompetitionId,
        EventId: "",
        apiReqBody: postBody,
      },
    });
    //  -------------------------------

    // try {
    //   this.appService.getOperatorConfigData(postBody).subscribe((res) => {
    //     if (res.status === "RS_OK") {
    //       this.configData = res.config;
    //       this.dialog.open(CommonModalComponent, {
    //         backdropClass: "backdropBackground",
    //         hasBackdrop: true,
    //         data: {
    //           ConfigData: res.config,
    //           ConfigCall: res.level,
    //           For: "OP",
    //           page: "competition",
    //           OperatorId: "",
    //           ProviderId: this.ProviderId,
    //           SportId: this.sportId,
    //           CompetitionId: data.CompetitionId,
    //           EventId: "",
    //         },
    //       });
    //     } else if (res.status === "RS_ERROR") {
    //       this.appService.openErrorBar(res.errorDescription);
    //     }
    //   });
    // } catch (err) {}
  }
}

@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./upload-modal-component.html",
  styleUrls: ["./competition-management.component.scss"],
})
export class UploadModalComponent {
  imgs = [
    // {
    //   id: 0,
    //   src: "../../../assets/thumb_cricket_odi.webp",
    // },
    // {
    //   id: 1,
    //   src: "../../../assets/thumb_cricket_t20.webp",
    // },
    // {
    //   id: 2,
    //   src: "../../../assets/thumb_cricket_test.webp",
    // },
    // {
    //   id: 3,
    //   src: "../../../assets/thumb_soccer.webp",
    // },
    // {
    //   id: 4,
    //   src: "../../../assets/thumb_tennis.webp",
    // },
  ];
  selectIds = [];
  DATA;
  constructor(
    public dialogRef: MatDialogRef<UploadModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private appService: AppService
  ) {
    this.DATA = data;
    console.log("data",data)
    for (let i = 0; i < this.DATA.thumbnails.length; i++) {
      let a = { id: null, src: null };
      a.id = i;
      a.src = this.DATA.thumbnails[i];
      if (this.DATA.selectedThumbnails.includes(a.src)) {
        this.selectIds.push(i);
      }
      this.imgs.push(a);
    }
  }

  ngOnInit() {}

  selectImg(id) {
    if(!this.selectIds.includes(id)){
      this.selectIds.push(id);
    }else{
      const index = this.selectIds.indexOf(id); 

      if (index !== -1) {
        this.selectIds.splice(index, 1); 
      } 
       }
    // console.log(this.imgs[id]);
  }

  getSelectedThumbnails(){
    let images = [];
    this.imgs.forEach((img)=>{
      if(this.selectIds.includes(img.id)){
        images.push(img.src)
      }
    })
    return images
  }

  submitImg() {
    this.appService
      .uploadThumbnail({
        competitionId: this.DATA.cid,
        thumbnailUrls: this.getSelectedThumbnails(),
        providerId: this.DATA.pid,
      })
      .subscribe(
        (res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar("Banner is updated");
            this.dialogRef.close();
          } else {
            this.appService.openErrorBar("Banner is not updated");
          }
        },
        (err) => {}
      );
  }
}
